import { useState } from 'react';
import { IconButton, Typography, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { CloseCircle, CloseSquare, Edit2, TickCircle, Trash } from 'iconsax-react';
import { observer } from 'mobx-react';
import { LoadingButton } from '@mui/lab';
import styles from './contacts.module.scss';

const TagItem = observer(({ show, setShow, uiStore, close, tag, deleteTag, updateTag }) => {
    const [editMode, setEditMode] = useState(false);
    const [value, setValue] = useState(tag.tag);
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    const saveEdit = () => {
        updateTag(tag._id, value);
        setEditMode(false)
    }

    const deleteT = async () => {
        deleteTag(tag._id);
        setShowDeleteModal(false);
    }

    return (
        editMode
            ?
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
                <TextField value={value} onChange={(e) => setValue(e.target.value)} size='small' />
                <Box>
                    <IconButton onClick={() => setEditMode(false)}>
                        <CloseCircle
                            variant='Bulk'
                            size='22'
                        />
                    </IconButton>
                    <IconButton onClick={saveEdit} color='secondary'>
                        <TickCircle
                            variant='Bulk'
                            size='22'
                        />
                    </IconButton>
                </Box>
            </Box>
            :
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, borderBottom: '1px solid #E3E8EF' }}>
                <Typography>{tag.tag}</Typography>
                <Box>
                    <IconButton onClick={() => setEditMode(true)}>
                        <Edit2
                            size="22"
                            variant="Bulk"
                            color="#000"
                        />
                    </IconButton>
                    <IconButton onClick={() => setShowDeleteModal(true)}>
                        <Trash
                            size="22"
                            variant="Bulk"
                            color="#000"
                        />
                    </IconButton>
                    <DeleteTagModal tag={tag} deleteTag={deleteT} show={showDeleteModal} setShow={setShowDeleteModal} />
                </Box>
            </Box>
    );
});

export default TagItem;

const DeleteTagModal = observer(({ tag, show, setShow, deleteTag }) => {
    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                <Box className={styles.deleteIconContainer}>
                    <Trash
                        size="30"
                        variant="Bulk"
                    />
                </Box>
                <Typography fontWeight={600}>Delete Tag</Typography>
                <Typography color='#888888'>Are you sure you want to delete {tag?.tag} tag?</Typography>
            </DialogContent>
            <DialogActions>
                <LoadingButton onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </LoadingButton>
                <LoadingButton onClick={deleteTag} variant="contained" color="error">
                    Delete
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
});